import React from 'react';
import styled from 'styled-components';
import PropTypes from "prop-types";
import RepeatedControl from "./RepeatedControl";

const Holder = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
`;

const Inner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

function PresetIcon(props) {
  return (
    <Holder>
      <Inner>
        <RepeatedControl customSettings={props.preset}/>
      </Inner>
    </Holder>
  )
}

PresetIcon.propTypes = {
  preset: PropTypes.object.isRequired,
};

export default PresetIcon;